<template>
    <b-card id="cedesViewer" header="SEDES Y GRUPOS">
        <b-form-group label-for="cedes_id" label="ESCUELA / EMPRESA">
            <b-select id="cedes_id" v-model="workingValue.cedes_id" :options="options"/>
        </b-form-group>
        <b-form-group label-for="grupos_id" label="GRUPO" v-if="workingValue.cedes_id">
            <b-select id="grupos_id" v-model="workingValue.grupos_id" :options="optionsGrupos" />
        </b-form-group>
    </b-card>
</template>

<script>
import _ from 'lodash'
import {startFilters} from './../Easylunch'
export default {
    name: 'cedesViewer',
    props: {
        value: {
            type: Object,
            default: startFilters
        },
        cedes: {
            type: Array
        },
        grupos: {
            type: Array
        }
    },
    data: () => {
        return {
            workingValue: startFilters()
        }
    },
    computed: {
        optionsGrupos(){
            let options = [
                {
                    value: null,
                    text: '-- Todas los grupos --'
                }
            ];
            _.forEach(_.filter(this.grupos, gr => {
                return (this.workingValue.cedes_id == null || this.workingValue.cedes_id == gr.lunch_cedes_id)
            }), grupo => {
                options.push({
                    value: grupo.id,
                    text: grupo.grupo_clase + " " + grupo.grupo_titulo
                })
            })
            return options;
        },
        options(){
            let options = [
                {
                    value: null,
                    text: '-- Todas las sedes --'
                }
            ];
             _.forEach(this.cedes, cede => {
                options.push({
                    value: cede.id,
                    text: cede.cede_titulo
                })
            })
            return options;
        }
    },
    methods: {
        updateParent(){
            this.$emit('input', _.clone(this.workingValue))
            this.$emit('changed', this.workingValue)
        }
    },
    watch: {
        'workingValue.cedes_id'(){
            if(this.value.cedes_id != this.workingValue.cedes_id){
                this.workingValue.grupos_id = null;
                this.updateParent()
            }
        },
        'workingValue.grupos_id'(){
            if(this.value.grupos_id != this.workingValue.grupos_id){
                this.updateParent()
            }
        }
    },
    beforeMount(){
        this.workingValue = _.clone(this.value)
    }
}
</script>

<style lang="less">
    #cedesViewer {
        select {
            width: 100%;
        }
    }
</style>